(function (global) {

  /**
  * Функции отвечающие за работу карточек.
  * @namespace Core.cards
  * @since 5.0.0.7100
  */
  global.cards = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Удаление строки детального раздела.
  * @function Core.cards.deleteTableRow
  * @since 5.0.0.7100
  * @return Core.cards
  */
  global.cards.deleteTableRow = function (el, rowNum) {
    ConfirmDialogNew({
      text: L("CONFIRM_TABLE_RECORD_DELETE"),
      okText: L("YES"),
      cancelText: L("NO"),
      ok: function () {
        var tbl = $(el).parents().filter('table:first');
        var detailNum = +tbl.data('section');
        WA.CR.form.controls.tables[tbl.data('name')].deleteRow(+rowNum);
      }
    });
    return this;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Установить доступность кнопок.
  * @since 5.5.2201
  */
  global.cards.enableButtonsOnFormChange = function (buttonNames) {
    var toolBar = WA.CR.toolBar;
    if (toolBar) {
      buttonNames.forEach(function (buttonName) {
        var button = toolBar.buttons[buttonName];
        if (button) {
          button.enable();
        }
      });
    }
  };
  //---------------------------------------------------------------------//

  /**
  * Установить доступность кнопок на ленте при изменении формы.
  * @since 5.5.2201
  */
  global.cards.bindButtonsEnablingOnFormChange = function (buttonNames) {
    // Флаг, указывающий необходимость осуществления блокировки кнопок не ленте
    // на основе режима доступности
    var isControlChangedBefore = false;
    $.when(WA.FormControlsInit, WA.FormInit, WA.ToolBarInit).done(function () {
      WA.CR.form.bind('change', function () {
        global.cards.enableButtonsOnFormChange(buttonNames);
        if (!isControlChangedBefore) {
          Core.cards.setButtonsEnablingOnEnabledMode();
          isControlChangedBefore = true;
        }
      });

      //подписываем реквизиты карточки на события ввода
      bindButtonsEnablingOnMainSectionRequisitesKeypress(buttonNames);
      bindButtonsEnablingOnDetailSectionRequisitesKeypress(buttonNames);
    });
  };

  /**
   * Делает конопки доступными при вводе на реквизиты основного раздела
   * @param {Array<string>} buttonNames названия кнопок
   */
  function bindButtonsEnablingOnMainSectionRequisitesKeypress(buttonNames) {
    WA.CR.form.requisites.toArray().forEach(function (req) {
      req.controls.forEach(function (c) {
        c.one('keypress',function () {
          global.cards.enableButtonsOnFormChange(buttonNames);
        });
      });
    });
  }

  /**
   * Делает конопки доступными при вводе на реквизиты детального раздела
   * @param {Array<string>} buttonNames названия кнопок
   */
  function bindButtonsEnablingOnDetailSectionRequisitesKeypress(buttonNames) {
    var tables = WA.CR.form.controls.tables;
    for (var tableName in tables) {
      tables[tableName].rows.toArray().forEach(function (row) {
        row.requisites.toArray().forEach(function (req) {
          req.bind('editModeChange', function () {
            req.controls.forEach(function(c) {
              c.one('keypress', function() {
                global.cards.enableButtonsOnFormChange(buttonNames);
              });
            });
          });
        });
      });
    };
  }

  /**
   * Установить доступность кнопок на ленте при изменении формы на основе режима доступности.
   * @since 5.5.2201
   */
  global.cards.setButtonsEnablingOnEnabledMode = function () {
    WA.CR.toolBar.buttons.getButtonsByEnabledMode(ACTION_ENABLED_MODE.ENABLED_ON_BROWSE).forEach(function (button) {
      button.disable();
    });
    WA.CR.toolBar.buttons.getButtonsByEnabledMode(ACTION_ENABLED_MODE.ENABLED_ON_EDIT).forEach(function (button) {
      button.enable();
    });
  };

})(window.Core);
